import classNames from 'classnames';

import basePlainTextOrHtmlParams from './base_plain_text_or_html_params';
import htmlTextRenderer from './html_text_renderer';

/**
 * Returns raw Html version of React PlainTextOrHtml component.
 * @param params
 * @returns {String}
 */
export default function plainTextOrHtmlRenderer(params) {
  const {className, showHtml, text, title} = basePlainTextOrHtmlParams(params);
  return showHtml
    ? htmlTextRenderer({className, text, title})
    : `<span class="${classNames(className)}" title="${title}">
                ${text}
            </span>`;
}
